import React from "react";

import { useOrgModParams } from "src/features/orgmod";
import { Header as BasicHealthHeader } from "src/modules/basic-health";
import { Header as HtxHeader } from "src/modules/htx";
import { Header as KdHeader } from "src/modules/kd";
import { Header as KtxHeader } from "src/modules/ktx";
import { Header as LtxHeader } from "src/modules/ltx";

export const Header: React.FunctionComponent = () => {
	const { mod } = useOrgModParams();
	if (mod === "htx" || mod === "htx_nm") {
		return <HtxHeader />;
	}
	if (mod === "ktx") {
		return <KtxHeader />;
	}
	if (mod === "kd") {
		return <KdHeader />;
	}
	if (mod === "basic_health") {
		return <BasicHealthHeader />;
	}
	if (mod === "ltx") {
		return <LtxHeader />;
	}
	return null;
};
